/* eslint-disable @typescript-eslint/no-floating-promises */

import React, { useState } from 'react';
import { Autocomplete, Box, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useQuery, useLazyQuery } from '@apollo/client';
import { GET_MEMBERS, GET_PROJECT_NAMES } from '../gql';

interface IProps {
  setResourceData: (
    value: {
      displayName: string;
      id: string;
    } | null
  ) => void;
  setProjectData: (
    value: {
      projectName: string;
      id: string;
    } | null
  ) => void;
}

function PendingActionsFilter({
  setResourceData,
  setProjectData
}: IProps): JSX.Element {
  const [resource, setResource] = useState<{
    displayName: string;
    id: string;
  } | null>(null);
  const [project, setProject] = useState<{
    projectName: string;
    id: string;
  } | null>(null);

  const { data } = useQuery(GET_PROJECT_NAMES);
  const projects: Array<{ projectName: string; id: string }> =
    data?.getProjects ?? [];

  const [
    getMembers,
    { loading: loadingMembers, error: membersError, data: membersData }
  ] = useLazyQuery(GET_MEMBERS);
  const members = membersData?.getMembers.data || [];

  return (
    <Box
      sx={{
        width: '100%',
        height: 'auto',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        gap: '20px'
      }}
    >
      <Autocomplete
        value={resource}
        onInputChange={(event, newInputValue) => {
          if (newInputValue !== '') {
            getMembers({ variables: { displayName: newInputValue } });
          }
        }}
        options={loadingMembers || membersError ? ['Loading...'] : members}
        getOptionLabel={(option) => option.displayName}
        onChange={(event, newValue) => {
          setResource(newValue);
          setResourceData(newValue);
        }}
        sx={{
          flexGrow: { xs: '1', lg: '0' },
          height: '48px',
          width: '235px',
          borderRadius: '8px',
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            maxHeight: '48px',
            fontSize: '13px',
            '& .MuiOutlinedInput-input::placeholder': {
              fontFamily: 'Be Vietnam Pro',
              fontSize: '16px',
              fontWeight: '500',
              color: '#5F6368',
              opacity: 1
            }
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Resource"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
          />
        )}
      />
      <Box
        sx={{
          display: 'flex',
          gap: '20px',
          flexWrap: 'wrap',
          flexGrow: { xs: '1', lg: '0' }
        }}
      >
        <Autocomplete
          value={project}
          onChange={(event, newValue) => {
            setProject(newValue);
            setProjectData(newValue);
          }}
          options={projects}
          getOptionLabel={(option) => option.projectName}
          sx={{
            flexGrow: '1',
            height: '48px',
            width: '245px',

            borderRadius: '8px',
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
              maxHeight: '48px',
              fontSize: '13px',
              '& .MuiOutlinedInput-input::placeholder': {
                fontFamily: 'Be Vietnam Pro',
                fontSize: '16px',
                fontWeight: '500',
                color: '#5F6368',
                opacity: 1
              }
            }
          }}
          renderInput={(params) => (
            <TextField {...params} placeholder="Filter By Project Name" />
          )}
        />
      </Box>
    </Box>
  );
}

export default PendingActionsFilter;
